import React from 'react'
import './Carouselbox.css'
import { Link } from 'react-router-dom';
import Carousel from 'react-multi-carousel'
import img1 from '../../assets/icons/icn-3.png'
import img2 from '../../assets/icons/icn-2.png'
import img3 from '../../assets/icons/icn-4.png'
import img4 from '../../assets/icons/icn-3.png'
import img5 from '../../assets/icons/icn-3.png'
import img6 from '../../assets/icons/icn-3.png'
import 'react-multi-carousel/lib/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };


const Carouselbox = () => {
  return (
       <div class="coursebox-section ws-section bg-5 dark-bg pb-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <h2 class="ws-section_heading pd-03">Dive Deep Into Our Expertise</h2>
                        </div>
                    <div class="col-lg-4 align-self-center mb-3">
                         <a href="/courses/">
                        <button class="btn-primary btn-icon" href="index.html#about">View All Courses<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                    </a>
                    </div>
                    <div class="col-lg-12 p-lg-5">
                        <h2 class="pb-3">Top Qualities That Make the Takshila VLSI Institute One of the Best</h2>
                        <div class="carousel-box">

                        <p className='txt-dark'>At the Takshila VLSI training institute, we are proud to say that we are definitely among the best in the world. This is as we are proud to tell that a crucial aspect of our training is delivering highest-quality coaching – and not just teaching – to our students. Our students are imparted with the best possible hands-on and project-based training they can get. When our students graduate, they leave with all the necessary skills that are required to take on any role that might be required of them by the industry. Check out the following features that put us atop a better part of the industry.</p>
                        
                        </div>
                    </div>

                </div>

                <Carousel responsive={responsive} arrows={false} showDots={true} autoPlay={true} infinite={true}
        >
        <div class="p-4">
        <div class="carousel-box">
            <div class="carousel-box-icon mb-4">
            <img src={img1} alt=''/>
            </div>
            <div class="carousel-box-bottom">
                <h3 class="carousel-box-title mb-3">Job Oriented VLSI Courses</h3>
                <p class="carousel-box-desc mb-3">As a full VLSI institute, we offer <strong><em><a href="https://www.takshila-vlsi.com/events/1-day-free-vlsi-training/">fully job oriented VLSI training programs</a></em></strong> that are quite extensive and feature a <strong><em><a href="https://www.takshila-vlsi.com/course-calendar/">VLSI course curriculum</a></em></strong> that is quite extensive. Our training packages cover right from design stages up to the final verification stage. Our institute offers job oriented VLSI and backend courses to help our students in securing their place in the VLSI market after they graduate.Our students undergo the best possible <strong><em>hands-on VLSI training</em></strong> from the foremost experts who feature more than twelve years’ experience in the industry.</p>
            </div>
        </div>
        </div>
        <div class="p-4">
        <div class="carousel-box">
            <div class="carousel-box-icon mb-4">
            <img src={img2} alt=''/>
            </div>
            <div class="carousel-box-bottom">
                <h3 class="carousel-box-title mb-3">VLSI Training for Freshers</h3>
                <p class="carousel-box-desc mb-3">At Takshila, it does not matter whether you have a little experience or are just hearing about VLSI for the first time. We offer training to students with all levels of experience including those who are complete freshers. Even if you are a complete beginner, you will receive extensive VLSI training with placement at the end of your studies.</p>
            </div>
        </div>
        </div>
        <div class="p-4">
        <div class="carousel-box">
            <div class="carousel-box-icon mb-4">
            <img src={img3} alt=''/>
            </div>
            <div class="carousel-box-bottom">
                <h3 class="carousel-box-title mb-3">VLSI Training Institutes with Placement</h3>
                <p class="carousel-box-desc mb-3">We run a group of some of the foremost VLSI institutes in varying locations across the whole world. We run some of the best VLSI institutes with placement opportunities in some of the best cities after you graduate. All of these institutes are 100% placement VLSI institutes so you can be rest assured that you will get a placement position after your studies. The major goal of our <strong><em><a href="https://www.takshila-vlsi.com/placements/">placement program</a></em></strong> is to help upcoming engineers to build the best and most rewarding career they can in the VLSI industry. Apart from training you diligently in some of the <strong><em>best VLSI training institutes</em></strong> around, we also coach you to become the best chip designer that you can be. Our training process enables you to learn even the most complicated technologies within a very short time and then be transformed into a professional within no time at all. That is the key point of our placement program.</p>
            </div>
        </div>
        </div>
        <div class="p-4">
        <div class="carousel-box">
            <div class="carousel-box-icon mb-4">
            <FontAwesomeIcon icon="fa-solid fa-location-dot" />
            </div>
            <div class="carousel-box-bottom">
                <h3 class="carousel-box-title mb-3">The Best Institutes in the Best Locations</h3>
                <p class="carousel-box-desc mb-3">We run some of the best VLSI institutes in some of the best possible locations around the world. Just check out our roll call: we have;<br/>
                <b>The best VLSI training institutes in Bangalore.</b>.<br/>
                <b>The best VLSI training institutes in Hyderabad.</b>.<br/>
                <b>The best VLSI training institutes in Marathahalli.</b>.<br/>
                <b>The best VLSI course you can ever get anywhere around the whole world.</b>.
                </p>
            </div>
        </div>
        </div>
        <div class="p-4">
        <div class="carousel-box">
            <div class="carousel-box-icon mb-4">
            <FontAwesomeIcon icon="fa-solid fa-microchip" />
            </div>
            <div class="carousel-box-bottom">
                <h3 class="carousel-box-title mb-3">Chip Design Training Institutes</h3>
                <p class="carousel-box-desc mb-3">Like has been mentioned, one of our major goals is to help our students to become the very best chip designers that they can ever be. Our process of training students in the design of chips enables them to learn even the most complicated of technologies within a truly short period. This is a core VLSI training that helps in ensuring that they are transformed into professionals within no time at all.</p>
            </div>
        </div>
        </div>
        <div class="p-4">
        <div class="carousel-box">
            <div class="carousel-box-icon mb-4">
            <FontAwesomeIcon icon="fa-solid fa-person-chalkboard" />
            </div>
            <div class="carousel-box-bottom">
                <h3 class="carousel-box-title mb-3">Industry Standard VLSI Training</h3>
                <p class="carousel-box-desc mb-3">Even though they offer the best training that meets the highest possible standards set by the industry, our institutes still qualify to be called the low cost VLSI training institutes of the entire industry. They could be called great VLSI coaching centers because what they offer is significantly beyond teaching. These institutes offer full time VLSI training, part time VLSI training, as well as quality online VLSI courses in varying categories and subject areas. We offer all of these pieces of training using the most superior training methodology as well as infrastructure. Our training programs are carefully designed by the foremost industry experts according to the job and career growth opportunities that are presently available in the industry.</p>
            </div>
        </div>
        </div>
        </Carousel>
                <div class="p-lg-4 mt-4">
            <div class="carousel-box">
            <div class="carousel-box-bottom">
                <h3 class="carousel-box-title mb-3">We Are Among the Top 10</h3>
                <p class="carousel-box-desc mb-3">We are among the <strong><em>top 10 VLSI training institutes</em></strong> you will find in the world. This is because we deliver real value for your money (in fact even significantly more than your money’s worth) by offering all advanced VLSI courses, including VLSI backend courses, at costs that are quite reasonable. We offer you a lot more for a lot less. This is because, despite the reasonable costs of our varying courses, they are taught to our students by the foremost experts of the entire industry from around the whole world. At Takshila, our experienced industry gurus share their experience with our students, and they help our students to build their promising careers in the VLSI industry. As a student, you are allowed to carry out practical examples and applications. These are only some of the reasons why we are among the topmost ten of the entire industry.<strong>&nbsp;</strong></p>
            <p class="carousel-box-desc mb-3">In conclusion, there is a wide range of amazing reasons why you should make sure that you enroll with the <strong><em>Takshila VLSI institute</em></strong> We offer placement opportunities to all of our students after they graduate, our <strong><em><a href="https://www.takshila-vlsi.com/product/analog-circuit-design-online/">chip design</a></em></strong> institute offers truly extensive programs that feature truly elaborate VLSI curriculums, and our training programs cover every single thing right from the design stage up to the final stage of verification. Our students are given real first-hand experience of what VLSI design and implementation are all about. And, we offer these at truly affordable and reasonable rates so, why don’t you enroll with us?</p>
            </div>
        </div>
        </div>
            </div>
        </div>
  )
}

export default Carouselbox